import { TntWorldMap } from './tntWorldMap';
import { BasicMapbox } from './basicMapbox';
import { BasicWorldMap } from "./basicWorldMap";
import { IGraphOptions } from "../../../modules/common/lib/types/selectedFilters";
export class GraphBuilder {
    private chart = undefined;
    private options: IGraphOptions;
    private milestone: number;
    constructor(milestone: number, options: IGraphOptions) {
        this.milestone = milestone;
        this.options = options;
    }

    public mapGraphData(data: any): void {
        if (data && data.graphData) {
            this.options.data = data.graphData;
            if (data.graphData.graphType) {
                this.options.graphType = data.graphData.graphType;
            }
        } else {
            this.options.data = {};
        }
        this.buildGraph();
    }

    public getOption(property: any) {
        return this.options[property];
    }

    public setOption(property: any, value: any) {
        return this.options[property] = value;
    }

    public getMilestone() {
        return this.milestone;
    }

    public getChart() {
        return this.chart;
    }


    public updateSeries() {
        console.log("update series", this.options);
    }

    public buildGraph() {
        switch (this.options.graphType) {
         
        
            case "basicWorldMap": {
                let basicWorldMap = new BasicWorldMap();
                basicWorldMap.buildGraph(this.options as any);
                this.chart = basicWorldMap.chart;
                break;
            }

            case "tntWorldMap": {
                let tntWorldMap = new TntWorldMap();
                tntWorldMap.buildGraph(this.options as any);
                this.chart = tntWorldMap.chart;
                break;
            }
            case "tntMapbox": {
                let tntMapbox = new BasicMapbox();
                tntMapbox.buildGraph(this.options as any);
                this.chart = tntMapbox.map;
                break;
            }
       
        }
    }
}
